const API_BASE = 'https://api.dev.auxo.dk';

/**
 * Fetch all items in a collection as a bare array.
 * @param {string} collectionName 
 * @returns {Promise<Array>}
 */
export async function fetchCollection(collectionName) {
  try {
    const response = await fetch(`${API_BASE}/public/content/${collectionName}`);
    if (!response.ok) {
      throw new Error(`Failed to fetch collection ${collectionName}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error fetching collection ${collectionName}:`, error);
    return [];
  }
}

/**
 * Fetch a single entry by its slug (localized to 'da').
 * @param {string} slug 
 * @returns {Promise<Object|null>}
 */
export async function fetchBySlug(slug) {
  try {
    const response = await fetch(`${API_BASE}/public/by-slug/da/${slug}`);
    if (!response.ok) {
      if (response.status === 404) return null;
      throw new Error(`Failed to fetch by slug ${slug}: ${response.statusText}`);
    }
    return await response.json();
  } catch (error) {
    console.error(`Error fetching by slug ${slug}:`, error);
    return null;
  }
}

/**
 * Fetch and structure menu items.
 * @returns {Promise<Array>}
 */
export async function fetchMenuItems() {
  const items = await fetchCollection('menu_items');
  // Sort by order ascending
  return items.sort((a, b) => (a.order || 0) - (b.order || 0));
}

/**
 * Fetch all galleries.
 * @returns {Promise<Array>}
 */
export async function fetchGalleries() {
  return await fetchCollection('gallery');
}

/**
 * Fetch a single page by its slug.
 * @param {string} slug 
 * @returns {Promise<Object|null>}
 */
export async function fetchPage(slug) {
  return await fetchBySlug(slug);
}

/**
 * Fetch a single gallery by its slug.
 * @param {string} slug 
 * @returns {Promise<Object|null>}
 */
export async function fetchGallery(slug) {
  return await fetchBySlug(slug);
}
